import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { updateItem } from "../../api/generics";
import AccountingEntry from "../../models/accounting-entries";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import { formatUTCDateTime } from "../../utils/dates";

interface AccountingEntryIgnoreModalProps {
  show: boolean;
  accountingentry?: AccountingEntry;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const AccountingEntryIgnoreModal: React.FC<AccountingEntryIgnoreModalProps> = ({
  show,
  accountingentry,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = accountingentry
    ? `Está seguro de que quiere eliminar el asiento contable: ${
        accountingentry.subject
      } - ${formatUTCDateTime(new Date(accountingentry.date!))}`
    : "";

  const onIgnoreClick = async () => {
    if (accountingentry !== undefined) {
      setSubmitting(true);
      let toSendAccountingEntry: AccountingEntry = {
        ...accountingentry,
        status: "ignored",
      };
      const accountingentryStatus = await updateItem<AccountingEntry>(
        `/accounting_entries/${accountingentry.id}/`,
        toSendAccountingEntry
      );

      if (accountingentryStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (accountingentryStatus.detail !== undefined) {
          message = accountingentryStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal
      show={show}
      className="modal-secondary"
      onClosed={onCancel}
      size="xl"
    >
      <CModalHeader closeButton></CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
              <h3 className="text-danger">Atención</h3>
              <h5>
                Si ignoras esta entrada no será tenida en cuenta en los reportes
                contables.
              </h5>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton
          disabled={submitting}
          onClick={onIgnoreClick}
          color="secondary"
        >
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Ignorando..." : "Ignorar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default AccountingEntryIgnoreModal;
